import { render } from "./app-modal-master-merchant-charges.vue?vue&type=template&id=3163ceec"
import script from "./app-modal-master-merchant-charges.vue?vue&type=script&lang=js"
export * from "./app-modal-master-merchant-charges.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-master-merchant-charges.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3163ceec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3163ceec', __exports__)) {
    console.log('reload')
    api.reload('3163ceec', __exports__)
  }
  
  module.hot.accept("./app-modal-master-merchant-charges.vue?vue&type=template&id=3163ceec", () => {
    console.log('re-render')
    api.rerender('3163ceec', render)
  })

}


export default __exports__